// Packages
import PropTypes from 'prop-types'

// Components
import NoteForm from 'modules/Notes/components/Form';

// Other
import useApi from 'hooks/useApi';

const NoteEditScreen = ({  itemId, onClose, onSubmit, parent, parentId }) => {

    const { data: item, put: updateItem, errors } = useApi('/notes/' + itemId);

	const submit = async (values) => {

        if( await updateItem({[parent]: parentId, ...values}, 'Note updated!')) {

            onSubmit();
        }
    }

    return(
        <NoteForm 
            errors={errors} 
            note={item} 
            onClose={onClose} 
            onSubmit={submit} 
            type='edit' 
        />
    )
}

NoteEditScreen.propTypes = {
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    parent: PropTypes.string,
    parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

NoteEditScreen.defaultProps = {
    itemId: null,
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')},
    parent: '',
    parentId: ''
}

export default NoteEditScreen;